webpackJsonp([263791100135453],{

/***/ 749:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/xav-ski.298f6070.jpg";

/***/ }),

/***/ 750:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/xav.1f04336c.jpg";

/***/ }),

/***/ 342:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(63);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _recompose = __webpack_require__(32);
	
	var _selectors = __webpack_require__(71);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var About = function About(_ref) {
	  var siteTitle = _ref.siteTitle;
	  return _react2.default.createElement(
	    'div',
	    { className: 'max-width-2 mx-auto px2' },
	    _react2.default.createElement(_reactHelmet2.default, { title: 'About | ' + siteTitle }),
	    _react2.default.createElement(
	      'div',
	      { className: 'sm-flex items-center' },
	      _react2.default.createElement(
	        'div',
	        { className: 'mr2 sm-col-4 max-width-1' },
	        _react2.default.createElement('img', {
	          src: __webpack_require__(750),
	          className: 'fit block'
	        })
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'sm-col-8' },
	        'Mono2Ski is run by professional ski instructor Xavier Raguin\u2014who has been instructing since 2001. Xavier has a vast knowledge of the main ski areas in the French Alps, including Espac\xE9 Killy, Paradiski and Les Trois Vallees.'
	      )
	    ),
	    _react2.default.createElement(
	      'blockquote',
	      { className: 'h3 italic gray line-height-3' },
	      _react2.default.createElement(
	        'p',
	        null,
	        'I created Mono2ski in order to provide my professional experience to skiers and snowboarders of all skill levels.\xA0I strive to offer the technical and analytical expertise of a private coach while ensuring that you enjoy every moment of your day, whether on marked runs or off-piste, so that you can improve your skill level under the best possible conditions.'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: '' },
	      _react2.default.createElement('img', {
	        src: __webpack_require__(749),
	        className: 'fit block'
	      })
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Xavier has a passion for challenging off-piste and technical piste skiing. As well as being a fully qualified ski instructor, he is also a fully qualified snowboard instructor and enjoys the teaching element greatly.'
	    )
	  );
	};
	
	var hoc = (0, _recompose.mapProps)(function (_ref2) {
	  var data = _ref2.data;
	  return {
	    siteTitle: (0, _selectors.getSiteTitle)(data)
	  };
	});
	
	exports.default = hoc(About);
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-6f9f43dcd719333375ab.js